import { defmulti } from "@thi.ng/defmulti";
import { Type } from "@thi.ng/geom-api";
import { add2, add3, set2, set3 } from "@thi.ng/vectors";
import { AABB } from "../api/aabb";
import { Circle } from "../api/circle";
import { Cubic } from "../api/cubic";
import { Ellipse } from "../api/ellipse";
import { Group } from "../api/group";
import { Line } from "../api/line";
import { Path } from "../api/path";
import { Points, Points3 } from "../api/points";
import { Polygon } from "../api/polygon";
import { Polyline } from "../api/polyline";
import { Quad } from "../api/quad";
import { Quadratic } from "../api/quadratic";
import { Ray } from "../api/ray";
import { Rect } from "../api/rect";
import { Sphere } from "../api/sphere";
import { Text } from "../api/text";
import { Triangle } from "../api/triangle";
import { copyAttribs } from "../internal/copy-attribs";
import { dispatch } from "../internal/dispatch";
import { translatedShape as tx } from "../internal/translate-points";
export const translate = defmulti(dispatch);
translate.addAll({
    [Type.AABB]: ($, delta) => new AABB(add3([], $.pos, delta), set3([], $.size), copyAttribs($)),
    [Type.ARC]: ($, delta) => {
        const a = $.copy();
        add2(null, a.pos, delta);
        return a;
    },
    [Type.CIRCLE]: ($, delta) => new Circle(add2([], $.pos, delta), $.r, copyAttribs($)),
    [Type.CUBIC]: tx(Cubic),
    [Type.ELLIPSE]: ($, delta) => new Ellipse(add2([], $.pos, delta), set2([], $.r), copyAttribs($)),
    [Type.GROUP]: ($, delta) => new Group(copyAttribs($), $.children.map((s) => translate(s, delta))),
    [Type.LINE]: tx(Line),
    [Type.PATH]: ($, delta) => new Path($.segments.map((s) => s.geo
        ? {
            type: s.type,
            geo: translate(s.geo, delta),
        }
        : {
            type: s.type,
            point: add2([], s.point, delta),
        }), copyAttribs($)),
    [Type.POINTS]: tx(Points),
    [Type.POINTS3]: tx(Points3),
    [Type.POLYGON]: tx(Polygon),
    [Type.POLYLINE]: tx(Polyline),
    [Type.QUAD]: tx(Quad),
    [Type.QUADRATIC]: tx(Quadratic),
    [Type.RAY]: ($, delta) => new Ray(add2([], $.pos, delta), $.dir, copyAttribs($)),
    [Type.RECT]: ($, delta) => new Rect(add2([], $.pos, delta), set2([], $.size), copyAttribs($)),
    [Type.SPHERE]: ($, delta) => new Sphere(add3([], $.pos, delta), $.r, copyAttribs($)),
    [Type.TEXT]: ($, delta) => new Text(add2([], $.pos, delta), $.body, copyAttribs($)),
    [Type.TRIANGLE]: tx(Triangle),
});
